<template>
  <div class="grid gap-x-8 gap-y-4" :class="gridColsClass">
    <div v-for="field in fields" :key="field.label">
      <span class="block text-label">{{ field.label }}</span>
      <a
        v-if="field.href"
        :href="field.href"
        target="_blank"
        rel="noopener noreferrer"
        class="text-headline text-primary hover:underline"
      >
        {{ field.value }}
      </a>
      <span v-else class="text-headline">{{ field.value }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { DisplayField } from "@/models/commercialData/OpenCorporates";

const { fields, cols = 2 } = defineProps<{
  fields: DisplayField[];
  cols?: 2 | 3 | 4;
}>();

const gridColsClass = computed(() => {
  const colsMap: Record<number, string> = {
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
  };
  return colsMap[cols];
});
</script>
